export const ANY_ROOM_TYPE = 'any';
export const MAX_ROOMS_LENGTH = 3;
